"use client";

import { usePathname } from "next/navigation";
import { AuthGuard } from "@/components/auth/auth-guard";
import { EntitlementGuardProvider } from "@/components/entitlement-guard/EntitlementGuardProvider";
import { CreditGuardProvider } from "@/components/credit-guard/CreditGuardProvider";
import { Sidebar } from "@/app/sidebar/sidebar";
import { TopLoader } from "@/components/ui/top-loader";
import { Toaster } from "@/components/ui/sonner";

export function ClientLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const isAuthRoute = pathname?.startsWith("/auth");

  return (
    <>
      <TopLoader />
      <Toaster />
      {isAuthRoute ? (
        children
      ) : (
        // The session check that used to live here moved into AuthGuard, so that
        // fetching the profile and acting on the result are the same decision
        // instead of two components racing to interpret it.
        <AuthGuard>
          {/* Inside AuthGuard on purpose: every query the guards make need the
              session, and the modals have nothing to say to somebody who isn't
              signed in. EntitlementGuardProvider wraps CreditGuardProvider: the
              entitlements gate comes first (is the user allowed?), then the
              credit gate (can they afford it?). */}
          <EntitlementGuardProvider>
            <CreditGuardProvider>
              <Sidebar>{children}</Sidebar>
            </CreditGuardProvider>
          </EntitlementGuardProvider>
        </AuthGuard>
      )}
    </>
  );
}
